import { supervisions } from 'STORE/modules/supervision/supervisions'
import { conquests } from 'STORE/modules/supervision/conquests'


export default {
    namespaced: true,
    modules: {
        supervisions,
        conquests,
    }
}